import { AuthService } from "./auth.service";
import { LayoutService } from "./layout.service";
import { PaymentService } from "./payment.service";
import { RefundService } from "./refund.service";
import { WalletService } from "./wallet.service";

export const CORE_SERVICES = [
  AuthService,
  LayoutService,
  WalletService,
  PaymentService,
  RefundService,
];
